import React, { useState } from 'react';
import { devError } from '../../utils/devLog';

const CopyButton = ({ text, position }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      devError('Failed to copy:', err);
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={`absolute ${position} opacity-0 group-hover:opacity-100 transition-opacity duration-200 p-1.5 bg-transparent rounded`}
      style={{ color: 'var(--text-primary)', zIndex: 10 }}
      aria-label="Copy message"
    >
      {copied ? (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      ) : (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
      )}
    </button>
  );
};

export default CopyButton;
